module.exports = __webpack_public_path__ + "img/logo.234bdae8.svg";